import {ref} from 'vue';
import {activityTrackerEndpoints} from '@registry';
import {defineStore} from 'pinia';
import {useLogger, useTranslation} from '#imports';
import type {ActivityTrackerResource} from '@api';

export const useActivityTrackerStore = defineStore('activity-tracker', () => {
    const logger = useLogger();

    const {t} = useTranslation();

    // fetched data
    const activityTracker = ref<ActivityTrackerResource>(null as unknown as ActivityTrackerResource);

    // loading state
    const loadingActivityTracker = ref(false);

    // notify on exception + redirect to project list
    async function fetchActivityTracker(projectId: string, lotId?: string) {
        try {
            loadingActivityTracker.value = true;
            if (lotId) activityTracker.value = await activityTrackerEndpoints.getActivityTracker({projectId, lotId: lotId!});
            else activityTracker.value = await activityTrackerEndpoints.getActivityTracker({projectId});
        } catch (e) {
            logger.error(e);
            activityTracker.value = null as unknown as ActivityTrackerResource;
        } finally {
            loadingActivityTracker.value = false;
        }
    }

    return {
        fetchActivityTracker,
        loadingActivityTracker,
        activityTracker,
    };
});
